
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */

// @mui material components
import { Box, Button, Modal, Pagination, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
// import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
// import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllMobileFinnance, createMobileFinnance, getAllAccount, deleteMobileFinnance } from "Redux/actions/mobileFinnance";


import './style.css';
import MultipleSelectPlaceholder from "./SlectComponent";
import { Stack } from "@mui/system";
import { createClient } from "Redux/actions/mobileFinnance";
import { getAllClients } from "Redux/actions/mobileFinnance";
import AlertDialog from "./dialog";
import CustomizedTables from "./tables";
import { getSingeClient } from "Redux/actions/mobileFinnance";
import { updateClient } from "Redux/actions/mobileFinnance";
import { deleteClient } from "Redux/actions/mobileFinnance";
import { updateMobileFinnance } from "Redux/actions/mobileFinnance";
import AddAccount from "./Component/addAccount";
import Loader from "components/loader/loader";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

// import DataTable from "examples/Tables/DataTable";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { sm: '100%', md: '80%', lg: '30%' },
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};
function Tables() {
  //all hooks
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  //client hooks
  const [clientError, setClientError] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [clientEditConfirm, setClientEditConfirm] = useState(false);
  const [client, setClient] = useState(localStorage.getItem("client") ? localStorage.getItem("client") : "");
  const [clientOpen, setClientOpen] = useState(false);
  const [editClient, setEditClient] = useState(false);
  const [clientData, setClientData] = useState({ name: "", number: "", service: "bKash", isInvestor: true });
  //account hooks
  const [openAccount, setOpenAccount] = useState(false);
  const [edit, setEdit] = useState(false);
  const [page, setPage] = useState(1);

  //mobile finnace hooks
  const [finnaceError, setFinnanceError] = useState('')
  const [formData, setFormData] = useState({
    service: "bKash",
    name: "",
    number: "",
    amount: 0,
    balance: 0,
    pin: "",
    type: "send",
    id: "",
    client: client,
    date: moment(new Date()).format("YYYY-MM-DD"),
  });
  //data fetching
  const mobileFinnance = useSelector((state) => state?.mobileFinnance);
  let account = useSelector((state) => state?.account);
  let loader = account?.loading
  account = account?.account
  let singleClient = useSelector((state) => state?.client);
  // console.log(singleClient)
  singleClient = singleClient?.singleClient?.client

  let count = (mobileFinnance?.mobileFinnance?.total / 10);


  //useEffect hooks
  useEffect(() => {
    dispatch(getAllMobileFinnance(1, 10, client, "bKash"));
    dispatch(getSingeClient(client, "bKash"))
    dispatch(getAllAccount("bKash"));
    dispatch(getAllClients("bKash"));
  }, [dispatch, client]);

  const handleClose = () => setOpen(false);

  const handleOpen = () => {
    setEdit(false);
    setFinnanceError('')
    setFormData({
      service: "bKash",
      name: "",
      number: "",
      amount: 0,
      balance: 0,
      pin: "",
      type: "send",
      id: "",
      client: client,
      date: moment(new Date()).format("YYYY-MM-DD"),


    });
    setOpen(true)
  };

  const handleSubmit = async () => {
    await dispatch(createMobileFinnance(formData, setOpen, setFinnanceError));
    await dispatch(getAllMobileFinnance(1, 10, client, "bKash"));
    await dispatch(getAllAccount("bKash"));

  }
  const hanldeAction = (item) => {
    setFormData({
      service: item.service,
      name: item.name,
      number: item.number,
      amount: item?.amount,
      balance: item?.balance,
      pin: item.pin,
      type: item.type,
      client: client,
      id: item._id,
      date: item?.date || moment(new Date()).format("YYYY-MM-DD"),
    });
    setEdit(true);
    setOpen(true);
  }
  const handleEdit =async (data) => {
    await dispatch(updateMobileFinnance(data,setOpen));

   await dispatch(getAllMobileFinnance(1, 10, client, "bKash"));
    
  }
  const handleDelete = async () => {
    await dispatch(deleteMobileFinnance(formData.id));

    await dispatch(getAllMobileFinnance(1, 10, client, "bKash"));
    setOpen(false);
    setConfirm(false);
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }
  const handleClientOpen = () => {
    setClientError("");
    setClientOpen(true);
  }

  const handleClient = (e) => {
    setClientData({ ...clientData, [e.target.name]: e.target.value })
  }
  const handleInvestor = (e) => {
    setClientData({ ...clientData, isInvestor: !(clientData.isInvestor) })

  }
  // console.log(singleClient)
  const handleClientEditOpen = () => {
    dispatch(getSingeClient(client, "bKash"));
    // console.log(singleClient)
    setClientData({
      name: singleClient?.name,
      number: singleClient.number,
      service: "bKash",
      isInvestor: singleClient.isInvestor,
      id: singleClient._id
    })
    setEditClient(true);
  }
  const handleClientEdit = async () => {
    await dispatch(updateClient(clientData));
    await dispatch(getAllClients("bKash"));
    setEditClient(false);
  }
  const handleDeleteClient = async () => {
    await dispatch(deleteClient(clientData.id,"bKash"))

    await dispatch(getAllClients("bKash"));
    setEditClient(false);
    setClientEditConfirm(false);
  }

  const handleClientSubmit = async () => {
    await dispatch(createClient(clientData, setClientOpen, setClientError));
    await getAllClients("bKash");
    await dispatch(getAllMobileFinnance(1, 10, client, "bKash"));

  }
  // hh
  const handleTransaction = (e, value) => {

    setPage(value);
    dispatch(getAllMobileFinnance(value, 10, client, "bKash"));
  }



  let actual = mobileFinnance?.mobileFinnance?.totalAmmount;
  let profit = mobileFinnance?.mobileFinnance?.profit;


  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loader ? <Loader /> :
        <>
           <MDBox
                  variant="gradient"
                  bgColor="bkash"
                  borderRadius="lg"
                  coloredShadow="bkash"
                  sx={{
                    height: "20%",
                    width: { xs: "100%", md: "100%", lg: "30%" },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <MDBox sx={{ color: 'success' }} className="">
                    <MDTypography variant='h3' style={{ color: "white", }}>Balance:<span className="value">৳ {account?.totalBalance}</span></MDTypography>
                    
                  </MDBox>
                </MDBox>
          <AddAccount
            openAccount={openAccount} setOpenAccount={setOpenAccount}
            style={style} handleChange={handleChange} edit={edit}
            formData={formData}
          />
         
          <MDBox pt={6} pb={4}>
            <Grid container spacing={3}>
              {/* <Grid item xs={12} lg={5}>
                <MDBox
                  variant="gradient"
                  bgColor="bkash"
                  borderRadius="lg"
                  coloredShadow="bkash"
                  sx={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <MDBox sx={{ color: 'success' }} className="content">
                    <MDTypography variant='h3' style={{ color: "white", }}>Balance</MDTypography>
                    <MDBox>

                      <span className="value">৳ {account?.totalBalance}</span>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Grid> */}
              <Grid item xs={12} lg={12} mt={1}>
                <Grid container spacing={3}>
                {account?.accounts?.map((item) =>
                  <MDBox variant="gradient"
                    bgColor="bkash"
                    borderRadius="lg"
                    coloredShadow="bkash"
                    sx={{
                      height: "30%",
                      width: { xs: "100%", md: "100%", lg: "30%"},
                      display: "flex",
                      marginLeft: "10px",
                      marginLeft: "10px", 
                      marginTop: "25px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >

                    <MDBox className="content2">
                      <h5 className="title1">{item?.number}</h5>
                      <MDBox>
                        {/* <span>৳</span> */}
                        <span className="value2">৳{item?.balance}</span>
                      </MDBox>

                    </MDBox>
                  </MDBox>)}
                  </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1} marginTop={2}>
              <Grid item xs={12} md={10} lg={5}>
                <MultipleSelectPlaceholder clients={mobileFinnance?.mobileFinnance?.clients} setClient={setClient} />
              </Grid>
              <Grid item xs={6} lg={2}>
                <div className="">
                  <button type="button" className="button-add2" onClick={() => handleClientEditOpen()}>Edit Client</button >
                  <Modal
                    open={editClient}
                    onClose={() => setEditClient(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <Typography id="modal-modal-title" variant="h6" component="h2">
                        Edit Client
                      </Typography>

                      <TextField id="standard-basic" className="input-field" name="name" onChange={handleClient} value={clientData.name} label="Name" variant="standard" required />
                      <TextField id="standard-basic" className="input-field" name="number" onChange={handleClient} value={clientData.number} label="Number" variant="standard" required />
                      <br />
                      <input type="checkbox" id="investor" name="investor" onChange={handleInvestor} checked={clientData.isInvestor} />
                      <label className="investor" for="investor">Investor</label>
                      <br />
                      <br />

                      <Button className="" onClick={handleClientEdit}>Edit</Button>

                      <Button className="" onClick={() => setClientEditConfirm(true)}>Delete</Button>
                      <AlertDialog open={clientEditConfirm} setOpen={setClientEditConfirm} handleDelete={handleDeleteClient} />

                    </Box>
                  </Modal>
                </div>
              </Grid>
              <Grid item xs={6} lg={2}>
                <div className="">
                  <button type="button" className="button-add2" onClick={handleClientOpen}>Add Client</button >
                  <Modal
                    open={clientOpen}
                    onClose={() => setClientOpen(!clientOpen)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <Typography id="modal-modal-title" variant="h6" component="h2">
                        Add Client
                      </Typography>

                      <TextField id="standard-basic" className="input-field" name="name" onChange={handleClient} label="Name" variant="standard" required />
                      <TextField id="standard-basic" className="input-field" name="number" onChange={handleClient} label="Number" variant="standard" required />
                      <br />
                      <input type="checkbox" id="investor" name="investor" onChange={handleInvestor} value={formData.isInvestor} />
                      <label className="investor" for="investor">Investor</label>
                      <br />
                      {clientError &&
                        <MDTypography variant="button" fontWeight="bold" color="error">
                          {clientError}
                        </MDTypography>
                      }
                      <br />
                      <Button className="" onClick={handleClientSubmit}>Submit</Button>
                    </Box>
                  </Modal>
                </div>
              </Grid>
              <Grid item xs={6} lg={2}>
                <div className="add-type1">
                  <button type="button" className="button-add1" onClick={handleOpen}><AddOutlinedIcon /></button >
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <Typography id="modal-modal-title" variant="h6" component="h2">
                        {edit ? "Edit Transaction" : "Add Transaction"}
                      </Typography>

                      <TextField id="standard-basic" className="input-field" name="number" onChange={handleChange} value={formData.number} label="Name/Number" variant="standard" required />
                      {/* <TextField id="standard-basic" className="input-field" name="number" onChange={handleChange} value={formData.number} label="Number" variant="standard" required /> */}
                      <TextField id="standard-basic" name="amount" onChange={handleChange} label="Amount" value={formData.amount} variant="standard" required />


                      <div className="select">
                        <TextField id="standard-basic" name="pin" onChange={handleChange} label="Pin" value={formData.pin} variant="standard" required />
                        <select name="type" onChange={handleChange} selected={formData.type} className="select-type" >
                          {edit && <option selected hidden value={formData.type}>{formData.type} </option>}
                          <option value="send">Send</option>
                          <option value="received">Received</option>

                        </select>
                      </div>

                      <label style={{ fontSize: "15px", color: "gray", display: "block", marginTop: "10px" }} htmlFor="">Date</label>
                      <input type="date" name="date" min={moment(new Date()).subtract(90, 'days').format("YYYY-MM-DD")} max={moment(new Date()).format("YYYY-MM-DD")} value={formData.date} onChange={handleChange} className="input-field time" />

                      <br />
                      {finnaceError &&
                        <MDTypography variant="button" fontWeight="bold" color="error">
                          {finnaceError}
                        </MDTypography>
                      }
                      <br />
                      {!edit && <Button sx={{ mt: "10px" }} className="" onClick={handleSubmit}>
                        Submit
                      </Button>}
                      {edit && <>
                        <Button sx={{ mt: "10px" }} onClick={() => handleEdit(formData)}>Edit</Button>

                        <Button sx={{ mt: "10px", ml: "10px" }} onClick={() => setConfirm(true)}>Delete</Button>
                        <AlertDialog open={confirm} setOpen={setConfirm} handleDelete={handleDelete} />

                      </>
                      }

                    </Box>
                  </Modal>
                </div>
              </Grid>
            </Grid>
          </MDBox>
          {mobileFinnance.loading && client !== '' ? <Loader /> : <>
            <div className="">
              {!(client === '') && <CustomizedTables transactions={mobileFinnance?.mobileFinnance?.mobileFinnance} handleAction={hanldeAction} service={"bKash"} />}
            </div>
            <Grid container>
              {(client !== '') && <Grid lg={6} xs={12}>
                Total:
                <div className="transaction">
                  <h3 className="title">{actual}</h3>
                </div>
              </Grid >}
              {(profit > 0 && client !== '') && <Grid lg={6} xs={12}>
                Profit:
                <div className="transaction">
                  <h3 className="title">{profit}</h3>
                </div>
              </Grid>}
            </Grid>
          </>}
          <Stack spacing={2}>
            <Pagination onChange={handleTransaction} count={Number(count + 1).toFixed(0)} page={page} variant="outlined" color="primary" />
          </Stack>
        </>}
    </DashboardLayout>
  );
}

export default Tables;
